<div
  class="save"
  data-test="saveDialog"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="dialogTitle">
  <form [formGroup]="form" (submit)="handleSubmit()">
    <h1 mat-dialog-title>
      {{ dialogTitle }}
    </h1>

    <p *ngIf="settings.message" class="save__message">
      {{ settings.message }}
    </p>

    <div mat-dialog-content>
      <div class="theme-light">
        <!-- info -->
        <app-form-field theme="light" label="Title">
          <input
            class="input"
            type="text"
            name="title"
            maxlength="60"
            #title
            autocomplete="off"
            formControlName="title"
            required
            aria-label="Title"
            data-test="bookmarkTitleInput" />
          <app-character-counter [field]="title"></app-character-counter>
          <mat-error *ngIf="form.get('title').invalid">Please enter a valid title.</mat-error>
        </app-form-field>

        <!-- only for group users -->
        <div *ngIf="canAddTeamBookmarks">
          <!-- permission -->
          <app-form-field *ngIf="isNew || isOwner" theme="light" label="Permissions">
            <mat-radio-group
              class="save__radio-group text-12 mt-2"
              formControlName="groupAccess"
              aria-label="Permission">
              <mat-radio-button value="" class="mb-2" data-test="groupAccessPrivateButton"
                >Private
              </mat-radio-button>
              <mat-radio-button value="view" class="mb-2" data-test="groupAccessViewButton"
                >Team - View Only
              </mat-radio-button>
              <mat-radio-button value="edit" data-test="groupAccessEditButton"
                >Team - View & Edit
              </mat-radio-button>
            </mat-radio-group>
          </app-form-field>

          <!-- collection -->
          <app-form-field
            theme="light"
            *ngIf="(collections$ | async)?.length > 0"
            label="Collection (Optional)"
            aria-label="Collection (Optional)"
            data-test="saveCollection"
            formArrayName="collections">
            <div
              *ngFor="let collection of collectionsArray.controls; let collectionIndex = index"
              [formGroupName]="collectionIndex">
              <mat-checkbox
                class="save__collection text-12"
                data-test="saveCollectionCheckbox"
                formControlName="checked">
                {{ collection.get('title').value }}
              </mat-checkbox>
            </div>
          </app-form-field>
        </div>

        <!-- public bookmarks -->
        <div *ngIf="!(organization$ | async) && settings.mode !== saveBookmarkDialogMode.Copy">
          <app-form-field theme="light" label="Share">
            <mat-checkbox class="save__permission" formControlName="publicAccess">
              <span class="text-12">With the BioDigital Community</span>
            </mat-checkbox>
          </app-form-field>
        </div>
      </div>
    </div>

    <!-- actions -->
    <div mat-dialog-actions>
      <button
        type="button"
        app-button
        buttonTheme="light"
        class="mr-2"
        (click)="handleCancelClick()">
        Cancel
      </button>
      <button
        type="submit"
        app-button
        buttonType="primary"
        [disabled]="disablePristine || collectionsLoading || (saving$ | async)"
        data-test="saveButton">
        {{ (saving$ | async) ? 'Saving' : 'Save' }}
        <app-spinner
          *ngIf="saving$ | async"
          size="medium"
          class="ml-2"
          render="inline"></app-spinner>
      </button>
    </div>
  </form>
</div>
